module.exports = {
	"shared.crew.original-music-composer": "Originele muziek/componist",
	"social-button.twitter": "Twitter",
	"shared.crew.publicist": "Publiceerder",
	"share-overlay.share": "Deze video delen",
	"shared.crew.associate-producer": "Productieassistent",
	"shared.crew.assistant-editor": "Assistent montage",
	"overlay.buy-from": "Kopen vanaf {price}",
	"shared.crew.agent": "Agent",
	"shared.crew.additional-photography": "Aanvullende fotografie",
	"shared.crew.sound-editor": "Geluidseditor",
	"shared.crew.print-shipper": "Print shipper",
	"shared.crew.hairstylist": "Hairstylist",
	"shared.crew.makeup-effects": "Make-upeffects",
	"social-button.pinterest": "Pinterest",
	"shared.crew.production-assistant": "Productieassistent",
	"shared.crew.executive-producer": "Uitvoerend producent",
	"shared.crew.costumer": "Costumer",
	"info-overlay.cast": "cast",
	"shared.crew.stunt-coordinator": "Stuntcoördinator",
	"shared.crew.academic-advisor": "Adviseur",
	"shared.crew.swing-gang": "Swing gang",
	"shared.crew.best-boy": "Best boy",
	"actions.purchased": "U hebt deze video al",
	"social-button.tumblr": "Tumblr",
	"quality.format": "{qualityValue}p",
	"shared.crew.set-decorator": "Setdecorator",
	"shared.crew.adaptation": "Adaptie",
	"shared.crew.school-administrator": "Schooldirecteur",
	"shared.crew.cable-person": "Bekabeling",
	"shared.crew.digital-effects": "Digitale effecten",
	"actions.rent": "Huren {price}",
	"info-overlay.created-by": "Door {author}",
	"social-share.twitter": "\"{title}\" bekijken via {siteUrl}",
	"shared.crew.production-designer": "Productiedesigner",
	"info-overlay.crew": "crew",
	"shared.crew.producer": "Producent",
	"shared.crew.2nd-unit-dir-of-photography": "Cameraregisseur tweede unit",
	"shared.crew.special-effects": "Special effects",
	"actions.rented": "Gehuurd tot {date}",
	"shared.crew.boom-operator": "Boomoperator",
	"shared.crew.story": "Verhaal",
	"shared.crew.script-supervisor": "Scriptsupervisor",
	"shared.crew.director": "Regisseur",
	"shared.crew.choreographer": "Choreografie",
	"shared.crew.production-manager": "Productiemanager",
	"quality.auto": "Auto",
	"shared.crew.lead-person": "Lead person",
	"shared.crew.location-manager": "Locatiemanager",
	"shared.crew.costume-designer": "Kledingontwerper",
	"fullscreen.exit": "Volledig scherm afsluiten",
	"shared.crew.technical-advisor": "Technisch adviseur",
	"shared.crew.editor": "Editor",
	"shared.crew.additional-grip": "Aanvullende grip",
	"actions.buy": "Kopen {price}",
	"shared.crew.assistant-camera": "Camera-assistent",
	"shared.crew.writer": "Schrijver",
	"social-share.pinterest": "{title} - {description}",
	"shared.crew.collaborating-director": "Meewerkende regisseur",
	"fullscreen.enter": "Volledig scherm",
	"shared.crew.animal-trainer": "Dierentrainer",
	"shared.crew.assistant-art-director": "Assistent-artdirector",
	"shared.crew.key-grip": "Key grip",
	"social-button.copy": "Kopiëren",
	"shared.crew.makeup-artist": "Make-upartiest",
	"overlay.source-error": "Video kan niet worden afgespeeld",
	"social-button.link": "Koppeling",
	"actions.buy-from": "Kopen vanaf {price}",
	"shared.crew.art-director": "Artdirector",
	"shared.crew.production-coordinator": "Productiecoördinator",
	"shared.crew.co-director": "Co-regisseur",
	"shared.crew.co-producer": "Co-producent",
	"shared.crew.video-operator": "Video-operator",
	"shared.crew.camera-operator": "Cameraman",
	"shared.crew.co-writer": "Co-schrijver",
	"shared.crew.set-designer": "Setdesigner",
	"shared.crew.preview-return": "Preview return",
	"shared.crew.property-master": "Property master",
	"shared.crew.cinematographer-dp": "Cinematografie/DP",
	"shared.crew.grip": "Grip",
	"social-share.tumblr": "{title} - {siteUrl}",
	"shared.crew.sound-mixer": "Geluidsmixer",
	"quality.label": "Kwaliteit",
	"social-button.facebook": "Facebook",
	"shared.crew.gaffer": "Gaffer",
	"shared.crew.assistant-director": "Regieassistent",
	"actions.subscribe": "Abonneren {price}/maand",
	"shared.crew.print-return": "Print return",
	"shared.crew.animator": "Animator",
	"shared.crew.dolly-grip": "Dollygrip",
	"shared.crew.manager": "Manager",
	"shared.crew.2nd-assistant-director": "Tweede regieassistent",
	"shared.crew.author-of-adapted-material": "Schrijver geadapteerd materiaal"
};


//////////////////
// WEBPACK FOOTER
// ./src/widget/player-widget/translations/widget-texts_nl.json
// module id = 1444
// module chunks = 0 1 2 3